import { Configuration, PublicClientApplication, LogLevel } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    // Single-tenant (AlphaBOLD) by default. At customer-portal go-live set
    // VITE_MSAL_AUTHORITY=https://login.microsoftonline.com/organizations so client
    // tenants can sign in; the backend allow-list (PORTAL_SIGNIN_ENABLED + per-org
    // portal_enabled) is the actual gate, so this is safe to flip independently.
    authority:
      import.meta.env.VITE_MSAL_AUTHORITY ||
      `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'common'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            break
          case LogLevel.Warning:
            console.warn(message)
            break
          default:
            break
        }
      },
    },
  },
}

export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    `api://${import.meta.env.VITE_AZURE_CLIENT_ID}/access_as_user`,
  ],
}

export const msalInstance = new PublicClientApplication(msalConfig)
